/**
 * PriorityMediumIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PriorityMediumIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M4.2 8.5c-.663 0-1.2.448-1.2 1s.537 1 1.2 1h15.6c.663 0 1.2-.448 1.2-1s-.537-1-1.2-1zm0 5c-.663 0-1.2.448-1.2 1s.537 1 1.2 1h15.6a1.3 1.3 0 0 0 .942-.38.9.9 0 0 0 .258-.62c0-.552-.537-1-1.2-1z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PriorityMediumIcon = makeIcon('PriorityMediumIcon', PriorityMediumIconSvg)
